const axios = require('axios');

const url = 'api/deployments/';

class DeploymentService {

	static getBackendApps() {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await axios.get(url + 'getBackendApps');
				const data = res.data;
				resolve(data);
			} catch (err) {
				reject(err);
			}
		});
	}

	static getVersions(env, app) {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await axios.get(url + 'getVersions', {
					params: {
						env: env,
						app: `${app}/`
					}
				});
				const data = res.data;
				resolve(data);
			} catch (err) {
				reject(err);
			}
		});
	}

	static getBranch(env, app, version) {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await axios.get(url + 'getBranch', {
					params: {
						bucket: env,
						key: `${app}/v${version}/version.json`
					}
				});
				const data = res.data;
				resolve(data);
			} catch (err) {
				reject(err);
			}
		});
	}

	static getFrontendBranch(env, app) {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await axios.get(url + 'getFrontendBranch', {
					params: {
						env: env,
						app: app
					}
				});
				const data = res.data;
				resolve(data);
			} catch (err) {
				reject(err);
			}
		});
	}

	static getBackendBranch(env, app) {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await axios.get(url + 'getBackendBranch', {
					params: {
						env: env,
						app: app
					}
				});
				const data = res.data;
				resolve(data);
			} catch (err) {
				reject(err);
			}
		})
	}

}

export default DeploymentService;